import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminUser } from '../hooks/useAdminUser';

export const AdminRoute = ({ children }: PropsWithChildren<{}>) => {
  const { isAdmin, loading } = useAdminUser();

  if (loading) return null;
  if (!isAdmin) return <Navigate to="/data-hub" replace />;

  return <>{children}</>;
};
